import React from "react"

import { IDVerificationStatus, LoanApplicationState } from "@lib/clients/nelo-api-client"

import { SessionData, SessionAction, FlowType } from "./session-types"

export interface SessionContextValue {
  isLoggedIn: boolean
  sessionData: SessionData
  dispatch: React.Dispatch<SessionAction>
  // Convenient methods
  updateProduct: (updates: Partial<SessionData["product"]>) => void
  updateUser: (updates: Partial<SessionData["user"]>) => void
  updateProgress: (updates: Partial<SessionData["progress"]>) => void
  updateFlowType: (flowType: FlowType) => void
  resetSession: () => void
  // Identity verification utilities
  refetchIdv: () => Promise<any>
  idvLoading: boolean
  idvStatus: IDVerificationStatus | null
  // Loan application utilities
  loanApplicationStatus: LoanApplicationState | null
  refetchLoanApplication: () => Promise<any>
}
